<template>
  <div class="input-wrapper">

    <label
        for="timezone"
        class="input-wrapper__label"
    >
        {{ ($t('companyFormData.timeZone')) }} *
    </label>

    <select
        id="timezone"
        v-model="selectedTimezone"
        class="input-wrapper__select"
    >
        <option
            v-for="timezone in timezones"
            :value="timezone.value"
            :key="timezone.value"
        >
            {{ timezone.label }}
        </option>
    </select>

  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import moment from 'moment-timezone'
export default {
  // Declare the emitted event
  emits: ['update:selectedTimezone'],

  // the underscore (_) - a convention to indicate that we are not using the props argument
  // { emit } - destructuring: extract the emit function from the context object,
  // it gives us direct access to the emit function for emitting custom events in the component
  setup (_, { emit }) {
    // Reactive stored data
    const selectedTimezone = ref('')
    const timezones = ref([])

    // Method
    const loadBrowserTimezone = () => {
      selectedTimezone.value = moment.tz.guess()
    }

    onMounted(() => {
      timezones.value = moment.tz.names().map((name) => ({
        value: name,
        label: `UTC ${moment.tz(name).format('Z')} ${name}`
      }))

      loadBrowserTimezone()
    })

    // Watch for changes in selectedTimezone and emit the event
    watch(selectedTimezone, (newVal) => {
      emit('update:selectedTimezone', newVal)
    })

    return {
      selectedTimezone, timezones, loadBrowserTimezone
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-wrapper {
      position: relative;

      &__select {
          display: block;
          width: 100%;
          border: 1px solid $border-color-primary;
          border-radius: 3px;
          padding: 10px 12px;
          box-sizing: border-box;
          font-weight: var(--fontweight-regular);
          transition: 0.3s ease;
          height: 2.75rem;
          background-color: var(--white0);
          color: var(--black950);
          outline: none;
      }
      &__label {
          text-align: left;

          @include input-label;
      }
  }
</style>
